import type { PackOffering } from '../customer_api';
import { formatMoney } from '../lib/format';

interface Props {
  offering: PackOffering;
  onBuy: () => void;
  disabled?: boolean;
}

export function PackOfferingCard({ offering, onBuy, disabled }: Props) {
  const title =
    offering.name && offering.name.trim().length > 0
      ? offering.name
      : `${offering.packSize}-visit pack`;

  return (
    <div
      style={{
        padding: '1.25rem',
        background: 'var(--surface, white)',
        borderRadius: '12px',
        border: '1px solid var(--border, oklch(0.915 0.005 80))',
        display: 'flex',
        flexDirection: 'column',
        gap: '0.5rem',
      }}
    >
      <div style={{ fontWeight: 600, fontSize: '0.95rem' }}>{title}</div>
      <div
        style={{
          fontSize: '0.78rem',
          color: 'var(--muted-foreground, oklch(0.52 0.008 75))',
        }}
      >
        <span className="num">{offering.packSize}</span> visits ·{' '}
        {offering.expiryMonths > 0 && (
          <>
            expires in <span className="num">{offering.expiryMonths}</span> months
          </>
        )}
      </div>
      {offering.description && (
        <div
          style={{
            fontSize: '0.82rem',
            color: 'var(--muted-foreground, oklch(0.52 0.008 75))',
            lineHeight: 1.4,
          }}
        >
          {offering.description}
        </div>
      )}
      <div
        style={{
          marginTop: '0.25rem',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: '0.75rem',
        }}
      >
        <span className="num" style={{ fontWeight: 600, fontSize: '1.1rem' }}>
          {formatMoney(offering.priceMinor, offering.currency)}
        </span>
        <button
          type="button"
          onClick={onBuy}
          disabled={disabled}
          style={{
            padding: '0.55rem 1.25rem',
            borderRadius: '8px',
            border: 'none',
            background: disabled
              ? 'var(--muted, oklch(0.94 0.005 80))'
              : 'var(--primary, oklch(0.43 0.18 263))',
            color: disabled ? 'var(--muted-foreground, oklch(0.52 0.008 75))' : 'white',
            fontSize: '0.875rem',
            fontWeight: 500,
            cursor: disabled ? 'not-allowed' : 'pointer',
          }}
        >
          Buy
        </button>
      </div>
    </div>
  );
}
